import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

import { Button, DialogModalWindow } from "src/components/shared";
import { models, FactorGrid } from "../Factor";
import {
  createQuestions,
  updateQuestion,
  deleteQuestion,
  deleteQuestions,
} from "src/actions/prioritize";
import collectionApi from "src/api/v2/CollectionApi";
import BlueSidebar from "./BlueSidebar";
import "./TemplateBrowser.scss";

const FACTORS_SOURCE = models.FactorsSource.TEMPLATE;

const TemplateBrowser = ({
  templateFactors,
  presets = [],
  collection = [],
  onCancel = () => {},
  onChoose = () => {},
  createQuestions,
  deleteQuestions,
  setPreset,
}: {
  templateFactors: models.FactorInterface[];
  presets: any[];
  collection: any;
  onCancel: () => void;
  onChoose: () => void;
  createQuestions;
  deleteQuestions;
  setPreset;
}) => {
  const setRedux = useDispatch();
  const [currentPreset, setCurrentPreset] = useState({});
  const [
    showChooseConfirmationDialog,
    setShowChooseConfirmationDialog,
  ] = useState(false);

  const categories = [
    { name: "POPin Templates", presets: presets.filter((p) => p.public) },
    { name: "Your Templates", presets: presets.filter((p) => !p.public) },
  ];

  useEffect(() => {
    const defaultPublicPreset = categories[0].presets[0];
    if (!currentPreset.id) setCurrentPreset(defaultPublicPreset);

    const fetchFactors = async () => {
      const factors = await collectionApi.getQuestionsByCollectionId(
        defaultPublicPreset.id
      );
      setRedux({ type: "SET_TEMPLATE_FACTORS", payload: factors });
    };

    if (!templateFactors) {
      fetchFactors();
    }
  }, [templateFactors, setRedux, categories, setCurrentPreset, currentPreset]);

  const onChoosePreset = async () => {
    setRedux({ type: "SET_CURRENT_FACTORS", payload: templateFactors });
    setPreset(currentPreset);
    if (onChoose) onChoose();

    await deleteQuestions({ parentId: collection.id });
    await createQuestions({ parentId: collection.id, questions: templateFactors });
  };

  return (
    <div className="templates_browser">
      <div className="templates">
        <BlueSidebar
          categories={categories}
          setCurrentPreset={setCurrentPreset}
        />

        <div className="templates__grid create-step2">
          <div className="template__details">
            <h2 className="template__name">{currentPreset.title}</h2>
            {/* <NewPreset setCurrentPreset={setCurrentPreset} factorsSource={FACTORS_SOURCE} /> */}
          </div>

          <div className="templates_grid-factors">
            <FactorGrid
              parentId={currentPreset.id}
              editable={!currentPreset.public}
              source={FACTORS_SOURCE}
            />
          </div>
        </div>
      </div>

      <div className="footer_buttons">
        <Button sm flat cancel onClick={onCancel}>
          Cancel
        </Button>
        <Button
          sm
          flat
          submit
          onClick={() => {
            setShowChooseConfirmationDialog(true);
          }}
        >
          Choose
        </Button>
      </div>

      <ChooseTemplateConfirmationDialog
        isOpen={showChooseConfirmationDialog}
        onCancel={() => {
          setShowChooseConfirmationDialog(false);
        }}
        onChoose={onChoosePreset}
      />
    </div>
  );
};

const ChooseTemplateConfirmationDialog = ({ isOpen, onCancel, onChoose }) => {
  return (
    <DialogModalWindow
      isOpen={isOpen}
      title="Replace existing factors?"
      onCancel={onCancel}
      onConfirm={onChoose}
      confirmBtnText="Yes, replace factors"
      alert={true}
    >
      <p>Choosing a new template will replace existing factors.</p>
      <p style={{ color: "#ff595c" }}>All participant scoring will be lost.</p>
    </DialogModalWindow>
  );
};

const mapStateToProps = ({ prioritize }) => {
  return {
    templateFactors: prioritize.templateFactors,
    presets: prioritize.presets,
    collection: prioritize.collection,
  };
};

export default connect(mapStateToProps, {
  createQuestions,
  updateQuestion,
  deleteQuestion,
  deleteQuestions,
})(TemplateBrowser);
